import {Action, Dispatch, Reducer } from "redux"
import { CorePasswordChangeInstanceSettings } from "../models/CoreInstanceSettings"
import { EmptyRequestState } from '../models/RequestState';
import StatusCode from '../util/StatusCode';
import InstanceClient from '../services/InstanceClient';

export enum PasswordChangeRoleSettingActionType {
    GET_PASSWORDCHANGEROLESETTING = 'GET_PASSWORDCHANGE_ROLESETTING',
    UPDATE_PASSWORDCHANGEROLESETTING = 'UPDATE_PASSWORDCHANGE_ROLESETTING'
}

export interface PasswordChangeRoleSettingState {
    settings?: CorePasswordChangeInstanceSettings
    updateStatus: EmptyRequestState
}

interface GetPasswordChangeRoleSettingAction extends Action<PasswordChangeRoleSettingActionType.GET_PASSWORDCHANGEROLESETTING> {
    instanceSettings: CorePasswordChangeInstanceSettings
}
interface UpdatePasswordChangeRoleSettingAction extends Action<PasswordChangeRoleSettingActionType.UPDATE_PASSWORDCHANGEROLESETTING> {
    updateStatus: EmptyRequestState
}

type PasswordChangeRoleSettingAction = GetPasswordChangeRoleSettingAction | UpdatePasswordChangeRoleSettingAction;

const initialState: PasswordChangeRoleSettingState = {
    settings: undefined,
    updateStatus: { code: StatusCode.NONE }
};

export const getPasswordChangeRoleSettings = () => (dispatch: Dispatch<GetPasswordChangeRoleSettingAction>) => {
    const url = '/api/core/instanceSettings/passwordChangeRoleSetting';
    InstanceClient.get<CorePasswordChangeInstanceSettings>(url)
        .then(res => {
            dispatch({
                type: PasswordChangeRoleSettingActionType.GET_PASSWORDCHANGEROLESETTING,
                instanceSettings: res.data,
            })
        });
};

export const updatePasswordChangeRoleSettings = (settings: CorePasswordChangeInstanceSettings) => (dispatch: Dispatch<UpdatePasswordChangeRoleSettingAction>) => {
    dispatch({ type: PasswordChangeRoleSettingActionType.UPDATE_PASSWORDCHANGEROLESETTING, updateStatus: { code: StatusCode.PENDING } });

    return InstanceClient.put('/api/core/instanceSettings/passwordChangeRoleSetting', settings)
        .then(response => {
            dispatch({ type: PasswordChangeRoleSettingActionType.UPDATE_PASSWORDCHANGEROLESETTING, updateStatus: { code: StatusCode.COMPLETE } });
            return response;
        })
        .catch(error => {
            dispatch({ type: PasswordChangeRoleSettingActionType.UPDATE_PASSWORDCHANGEROLESETTING, updateStatus: { code: StatusCode.ERROR, error } });
            return null;
        })
        .finally(() => {
            setTimeout(() => {
                dispatch({ type: PasswordChangeRoleSettingActionType.UPDATE_PASSWORDCHANGEROLESETTING, updateStatus: { code: StatusCode.NONE } });
            }, 3000);
        });
}

export const resetUpdatePasswordChangeRoleSettings = () => (dispatch: Dispatch<UpdatePasswordChangeRoleSettingAction>) => {
    dispatch({ type: PasswordChangeRoleSettingActionType.UPDATE_PASSWORDCHANGEROLESETTING, updateStatus: { code: StatusCode.NONE } });
}
export const reducer: Reducer<PasswordChangeRoleSettingState, PasswordChangeRoleSettingAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case PasswordChangeRoleSettingActionType.GET_PASSWORDCHANGEROLESETTING:
            return {
                ...state,
                settings: action.instanceSettings
            }
        case PasswordChangeRoleSettingActionType.UPDATE_PASSWORDCHANGEROLESETTING:
            return {
                ...state,
                updateStatus: action.updateStatus,
            }
        default:
            return state;
    }
}